import { useQueryClient } from "@tanstack/react-query";
import { PropsWithChildren, createContext } from "react";
import { usePreferences, usePreferencesMutation } from "../hooks/useAccount";
import { useBike } from "../hooks/useBikes";
import { Bike } from "../http/onlyclicksApi";

interface BikeContextType {
  bike?: Bike;
  isPending: boolean;
  setBike: (bike?: Bike) => Promise<void>;
}

export const BikeContext = createContext<BikeContextType>(undefined!);

export const BikeProvider = ({ children }: PropsWithChildren) => {
  const { data: preferences, isPending: prefsPending } = usePreferences();
  const preferencesMutation = usePreferencesMutation();
  const queryClient = useQueryClient();

  const { data: bike, isPending } = useBike(preferences?.selected_bike);

  const setBike = async (bike?: Bike) => {
    if (preferences === undefined) {
      return;
    }

    await queryClient.cancelQueries({
      queryKey: ["bike", preferences?.selected_bike],
      exact: true,
      fetchStatus: "fetching",
    });
    await preferencesMutation.mutateAsync({
      ...preferences,
      selected_bike: bike?.id,
    });
  };

  const value = {
    bike,
    isPending: isPending || prefsPending,
    setBike,
  };

  return <BikeContext value={value}>{children}</BikeContext>;
};
